import { writable } from 'svelte/store';

const createRouteToDeviceSettings = () => {
	//store for routing to every device drawer setting + sub setting
	// for example: go to Firmware version -> send device id, 'settings', 'firmware_version'
	// check all settings & subSettings in device_config
	const { subscribe, set, update } = writable({});

	return {
		subscribe,
		setTarget: (id, setting, subSetting = '', params = '') => {
			update((settings) => {
				settings[id] = {
					setting: setting,
					subSetting: subSetting,
					params: params,
				};
				return settings;
			});
		},
		resetTarget: () => set({}),
	};
};

export const routeToDeviceSettings = createRouteToDeviceSettings();
